const SUPPORTED_LOCALES = ['en', 'ru'];

export const getLocale = (): string => {
  const savedLocale = localStorage.getItem('locale');

  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
    return savedLocale;
  }

  const browserLocale = navigator.language?.split('-')[0];

  return SUPPORTED_LOCALES.includes(browserLocale) ? browserLocale : 'en';
};

export const setLocale = (locale: string) => {
  localStorage.setItem('locale', locale);
};
